import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		transform: "translate(4 2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7 1.00027L6.3374 1.23411C3.75867 2.14427 2.46928 2.59935 1.73464 3.63769C1 4.67603 1 6.04337 1 8.77807V11.2225C1 13.9572 1 15.3245 1.73464 16.3629C2.46928 17.4012 3.75867 17.8563 6.3374 18.7665L7 19.0003",
			stroke: "#FF537F",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	}), /* @__PURE__ */ _jsx("g", {
		transform: "translate(10 8.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11 3.5H1M11 3.5C11 2.7998 9.0057 1.49153 8.5 1M11 3.5C11 4.2002 9.0057 5.5085 8.5 6",
			stroke: "#FF537F",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
export default SvgLogout;
